import { render, staticRenderFns } from "./CardShippingFeesTable.vue?vue&type=template&id=5ca65b6c&"
import script from "./CardShippingFeesTable.vue?vue&type=script&lang=js&"
export * from "./CardShippingFeesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports